var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-indicator d-flex justify-content-center align-items-center"},[_c('img',{directives:[{name:"svg-inline",rawName:"v-svg-inline"}],staticClass:"scroll-indicator__icon",class:`fill-${_vm.variant}`,attrs:{"src":require("@/assets/ui/scrollbar_01.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }